import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { PlanService } from '../../data-access/plan.service';
import { Subject, takeUntil } from 'rxjs';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Plan } from '../../interfaces/plan.interface';
import { Client } from '../../interfaces/client.interface';
import { ClientService } from '../../data-access/client.service';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule
  ],
  providers: [
    PlanService,
    ClientService
  ],
  selector: 'equine-ui-nx-plan-admin',
  templateUrl: './plan-admin.component.html',
  styleUrls: ['./plan-admin.component.css']
})
export class PlanAdminComponent implements OnInit, OnDestroy {

  #planService = inject(PlanService);
  #clientService = inject(ClientService);
  unsubscribe$ = new Subject<void>();
  id = '';
  form: FormGroup;
  clients: Client[] = [];
  plans: Plan[] = [];
  showPlans: boolean = false;

  constructor() {
    this.form = new FormGroup({
      fee: new FormControl(''),
      percentageFee: new FormControl(''),
      customerId: new FormControl('', Validators.required),
      planName: new FormControl('', Validators.required)
    });
  }

  createNew() {
    if (this.form.valid) {
      this.#planService.create(this.form.value)
        .pipe(
          takeUntil(this.unsubscribe$)
        )
        .subscribe({
          next: (response) => {
            this.id = response.id;
            if (this.showPlans) {
              this.fetchPlans();
            }
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    this.fetchClients();
    this.fetchPlans();
  }

  fetchClients() {
    this.#clientService.getAll()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: (clients) => this.clients = clients
    });
  }

  fetchPlans() {
    this.#planService.getAll()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe({
      next: (plans) => this.plans = plans
    })
  }

  toggleShowPlans() {
    this.showPlans = !this.showPlans;
    if (this.showPlans) {
      this.fetchPlans();
    }
  }

  editPlan(plan: Plan) {
    plan.isEditing = true;
  }

  cancelEditing(plan: Plan) {
    plan.isEditing = false;
  }

  updatePlan(plan: Plan) {
    if (!plan.isEditing) return;
    const updatedPlan = {
      fee: plan.fee,
      percentageFee: plan.percentageFee,
      customerId: plan.customerId,
      planName: plan.planName
    };
    this.#planService.update(plan.id, updatedPlan)
      .subscribe({
        next: () => {
          plan.isEditing = false;
          this.fetchPlans();
        }
      });
  }

  deletePlan(id: string) {
    this.#planService.delete(id).subscribe(() => {
      this.fetchPlans();
    });
  }

}
